import React from 'react';
;
const JudgemeReviewWidget = ({ id }) => {
    const shopifyId = id ? id.replace('gid://shopify/Product/', '') : "";
    return React.createElement("div", { className: "jdgm-widget jdgm-review-widget", "data-id": shopifyId });
};
export default JudgemeReviewWidget;
//# sourceMappingURL=JudgemeReviewWidget.client.js.map